var _g, _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchematic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2393 795",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "schematic") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Devices-(Digital-Twin)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-(Statclave):-More-Details---Vertical",
    transform: "translate(-392.000000, -437.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "schematic",
    transform: "translate(392.000000, 437.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1974,449.982877 L1974,563 L1863,563 L1863,380 L1974,380 L1974,405.90411",
    id: "Path",
    stroke: "#6C757D",
    strokeDasharray: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1596,68.8571429 L1596,161 L1213,161 L1213,3 L1596,3 L1596,20.4285714 L1596,68.8571429 Z",
    id: "Path",
    stroke: "#6C757D",
    strokeDasharray: 3
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#00AEEF",
    strokeWidth: 3,
    points: "752 481 752 534 1910 534"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#EC008C",
    strokeWidth: 3,
    points: "1512 129.5 1409.11831 130 1409.11831 312 1195 311"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1829,
    y1: 129.104895,
    x2: 1533,
    y2: 128.79021,
    id: "Path",
    stroke: "#EC008C",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#EC008C",
    strokeWidth: 3,
    points: "1829 174 1583 173 1583 495 1914.5 493"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1913,
    y1: 435,
    x2: 1913,
    y2: 622,
    id: "Path",
    stroke: "#EC008C",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1913,
    y1: 257,
    x2: 1913,
    y2: 405,
    id: "Path",
    stroke: "#EC008C",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#00AEEF",
    strokeWidth: 3,
    points: "629 395 752 395 752 460"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#F7C556",
    strokeWidth: 3,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "1863.34717 78.9387584 1863.34717 24 2051 24 2051 78.9387584 2003.66792 78.9387584 2003.66792 228.505872 1940.83774 228.505872 1940.83774 273 1890.36415 273 1890.36415 228.505872 1829 228.505872 1829 78.9387584"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#F7C556",
    strokeWidth: 2,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 1914,
    cy: 52.5,
    rx: 35,
    ry: 19.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#F7C556",
    fill: "#F7C556",
    fillRule: "nonzero",
    cx: 1914,
    cy: 52,
    rx: 7,
    ry: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1916,33 C1916,33 1928.70949,40.258427 1919.87747,52",
    id: "Path",
    stroke: "#F7C556"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1894,36 C1894,36 1916.74783,38.2647059 1918,50",
    id: "Path",
    stroke: "#F7C556"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1880,47.4648148 C1880,47.4648148 1899.05325,40.4930556 1915,50",
    id: "Path",
    stroke: "#F7C556"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1882,61 C1882,61 1890.68966,47.875503 1912,50.298487",
    id: "Path",
    stroke: "#F7C556"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1898.87913,71 C1898.87913,71 1893.13766,55.2553191 1911,51",
    id: "Path",
    stroke: "#F7C556"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1925,72 C1925,72 1902.22736,60.0851064 1912.80037,52",
    id: "Path",
    stroke: "#F7C556"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1944,62.7981694 C1944,62.7981694 1918.59854,65.3897301 1915,52",
    id: "Path",
    stroke: "#F7C556"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1949,49 C1949,49 1932.5,60.0510204 1916,52.1574344",
    id: "Path",
    stroke: "#F7C556"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1939,38 C1939,38 1934.80952,52.6153119 1917,51.9798636",
    id: "Path",
    stroke: "#F7C556"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#F7C556",
    strokeWidth: 2,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 1996,
    cy: 52.5,
    rx: 35,
    ry: 19.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#F7C556",
    fill: "#F7C556",
    fillRule: "nonzero",
    cx: 1996,
    cy: 52,
    rx: 7,
    ry: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1998,33 C1998,33 2010.70949,40.258427 2001.87747,52",
    id: "Path",
    stroke: "#F7C556"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1975,36 C1975,36 1997.74783,38.2647059 1999,50",
    id: "Path",
    stroke: "#F7C556"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1962,47.4648148 C1962,47.4648148 1981.05325,40.4930556 1997,50",
    id: "Path",
    stroke: "#F7C556"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1964,61 C1964,61 1972.68966,47.875503 1994,50.298487",
    id: "Path",
    stroke: "#F7C556"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1980.87913,71 C1980.87913,71 1975.13766,55.2553191 1993,51",
    id: "Path",
    stroke: "#F7C556"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2007,72 C2007,72 1984.22736,60.0851064 1994.80037,52",
    id: "Path",
    stroke: "#F7C556"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2026,62.7981694 C2026,62.7981694 2000.59854,65.3897301 1997,52",
    id: "Path",
    stroke: "#F7C556"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2031,49 C2031,49 2014.3949,60.0510204 1998,52.1574344",
    id: "Path",
    stroke: "#F7C556"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2021,38 C2021,38 2016.80952,52.6153119 1999,51.9798636",
    id: "Path",
    stroke: "#F7C556"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1570.18919,253 L1601.81081,253 C1617.86486,253 1631,264.308901 1631,278.13089 L1631,427.86911 C1631,441.691099 1617.86486,453 1601.81081,453 L1570.18919,453 C1554.13514,453 1541,441.691099 1541,427.86911 L1541,278.13089 C1541,264.099476 1554.13514,253 1570.18919,253 Z",
    id: "Path",
    stroke: "#6DC497",
    strokeWidth: 3,
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Vacuum-Pump-##",
    fontFamily: "Roboto-Medium, Roboto",
    fontSize: 14,
    fontWeight: 400,
    "line-spacing": 21,
    letterSpacing: 0.233333333,
    fill: "#212529"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1563.31191,
    y: 346
  }, "Vacumm"), /*#__PURE__*/React.createElement("tspan", {
    x: 1582.77565,
    y: 367
  }, "Pump"), /*#__PURE__*/React.createElement("tspan", {
    id: "Vacuum-Pump-##-3",
    className: "value",
    x: 1582.94349,
    y: 388
  }, "##")), /*#__PURE__*/React.createElement("path", {
    d: "M1542.3125,244 L1545.6875,244 C1559.60938,244 1571,255.322581 1571,269.16129 L1571,309.83871 C1571,323.677419 1559.60938,335 1545.6875,335 L1542.3125,335 C1528.39062,335 1517,323.677419 1517,309.83871 L1517,269.16129 C1517,255.112903 1528.39062,244 1542.3125,244 Z",
    id: "Path",
    stroke: "#6DC497",
    strokeWidth: 3,
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1542.3125,361 L1545.6875,361 C1559.60938,361 1571,372.245119 1571,385.989154 L1571,432.010846 C1571,445.754881 1559.60938,457 1545.6875,457 L1542.3125,457 C1528.39062,457 1517,445.754881 1517,432.010846 L1517,385.989154 C1517,372.245119 1528.39062,361 1542.3125,361 Z",
    id: "Path",
    stroke: "#6DC497",
    strokeWidth: 3,
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1883,629 L1883,643.101382 C1883,643.101382 1925.07792,656.373272 1964,643.101382 L1964,629",
    id: "Path",
    stroke: "#F7C556",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#F7C556",
    strokeWidth: 2,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 1923.5,
    cy: 627,
    rx: 40.5,
    ry: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#F7C556",
    strokeWidth: 2,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 1909,
    y: 609,
    width: 9,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#F7C556",
    strokeWidth: 2,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 1929,
    y: 609,
    width: 9,
    height: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1960.20995,644 C1949.79414,645.847787 1928.33757,650.9292 1887.7159,644 L1887.7159,650.467253 C1887.7159,650.467253 1867.3009,667.867244 1867.09259,671.408835 C1866.88427,674.950426 1867.09259,771.651261 1867.09259,771.651261 C1867.09259,771.651261 1866.46764,789.359216 1912.50553,793.516736 C1915.63027,794.132665 1929.58746,794.132665 1934.79537,793.670718 C1948.54424,792.284878 1979.58337,787.357447 1979.58337,773.037101 C1980,768.263652 1980,671.562817 1980,671.562817 C1980,671.562817 1971.0424,660.784062 1960.00164,649.54336 L1960.20995,644 Z",
    id: "Path",
    stroke: "#F7C556",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#00AEEF",
    strokeWidth: 2,
    x: 828,
    y: 221,
    width: 367,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#00AEEF",
    strokeWidth: 2,
    x: 828,
    y: 388,
    width: 367,
    height: 15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 629,
    y1: 359,
    x2: 629,
    y2: 648,
    id: "Path",
    stroke: "#EC008C",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#EC008C",
    strokeWidth: 3,
    points: "501 340 501 98 629 98 629 337.697232"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 501,
    y1: 648,
    x2: 501,
    y2: 361,
    id: "Path",
    stroke: "#EC008C",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543,292.179169 C543,292.179169 528.911215,306.207051 498,305.997679 C464.35514,305.997679 453,292.179169 453,292.179169 L453,178.07177 C453,174.721828 455.733645,172 459.098131,172 L534.799065,172 C539.214953,172 542.78972,175.559313 542.78972,179.956112 L542.78972,179.956112 L543,292.179169 Z",
    id: "Path",
    stroke: "#EC008C",
    strokeWidth: 3,
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#EC008C",
    strokeWidth: 3,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 498,
    cy: 172.5,
    rx: 45,
    ry: 9.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672,292.179169 C672,292.179169 657.911215,306.207051 627,305.997679 C593.35514,305.997679 582,292.179169 582,292.179169 L582,178.07177 C582,174.721828 584.733645,172 588.098131,172 L663.799065,172 C668.214953,172 671.78972,175.559313 671.78972,179.956112 L671.78972,179.956112 L672,292.179169 Z",
    id: "Path",
    stroke: "#EC008C",
    strokeWidth: 3,
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#EC008C",
    strokeWidth: 3,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 627,
    cy: 172.5,
    rx: 45,
    ry: 9.5
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#EC008C",
    strokeWidth: 3,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "486.848665 468.88758 486.848665 424 514.059347 424 514.059347 468.88758 534 468.88758 534 574.11242 514.059347 574.11242 514.059347 619 488.302671 619 488.302671 572.024625 464 572.024625 464 468.88758"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#EC008C",
    strokeWidth: 3,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "613.316568 468.069519 613.316568 423 640.83432 423 640.83432 468.069519 661 468.069519 661 573.720856 640.83432 573.720856 640.83432 619 614.576923 619 614.576923 571.834225 590 571.834225 590 468.069519"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 59,
    y1: 707,
    x2: 59,
    y2: 765,
    id: "Path",
    stroke: "#EC008C",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#EC008C",
    strokeWidth: 3,
    points: "358 646 61.5195312 645.5 59.5 768"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#00AEEF",
    strokeWidth: 3,
    points: "1368 84 1368 295 1195 295"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1368.5,
    y1: 43.5,
    x2: 1368,
    y2: 74,
    id: "Path",
    stroke: "#00AEEF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486,379 L501,353.730924 L516,379 L486,379 Z M486,327 L515.788732,327 L500.788732,352.269076 L486,327 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.852273,329.163569 L506.386364,338.531599 L500.710227,348.107807 L495.034091,338.531599 L489.568182,329.163569 L511.852273,329.163569 M500.5,357.892193 L506.176136,367.468401 L511.642045,376.836431 L489.357955,376.836431 L494.823864,367.468401 L500.5,357.892193 M519,325 L482,325 L491.25,340.613383 L498.397727,352.895911 L491.25,365.178439 L482,381 L519,381 L509.75,365.386617 L502.602273,353.104089 L509.75,340.821561 L519,325 L519,325 Z",
    id: "Shape",
    fill: "#3F2F90",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614,379 L629,353.730924 L644,379 L614,379 Z M614,327 L643.788732,327 L628.788732,352.269076 L614,327 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.683616,329.179104 L634.039548,338.58209 L628.39548,348.19403 L622.960452,338.58209 L617.316384,329.179104 L639.683616,329.179104 M628.39548,358.014925 L634.039548,367.626866 L639.474576,377.029851 L617.316384,377.029851 L622.751412,367.626866 L628.39548,358.014925 M646.79096,325 L610,325 L619.40678,340.671642 L626.514124,353 L619.40678,365.328358 L610.20904,381 L647,381 L637.80226,365.328358 L630.694915,353 L637.80226,340.671642 L646.79096,325 L646.79096,325 Z",
    id: "Shape",
    fill: "#3F2F90",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45,749 L60,723.629032 L75,749 L45,749 Z M45,697 L74.7887324,697 L59.7887324,722.370968 L45,697 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6420455,699.179104 L65.1761364,708.58209 L59.5,718.19403 L53.8238636,708.58209 L48.3579545,699.179104 L70.6420455,699.179104 M59.5,727.80597 L65.1761364,737.41791 L70.6420455,746.820896 L48.3579545,746.820896 L53.8238636,737.41791 L59.5,727.80597 M78,695 L41,695 L50.25,710.671642 L57.3977273,723 L50.25,735.328358 L41,751 L78,751 L68.75,735.328358 L61.6022727,723 L68.75,710.671642 L78,695 Z",
    id: "Shape",
    fill: "#3F2F90",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737,492.791165 L752,467.730924 L767,493 L737,492.791165 Z M737,441 L766.788732,441 L751.788732,466.269076 L737,441 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.852273,443.179104 L757.386364,452.58209 L751.710227,462.19403 L746.034091,452.58209 L740.568182,443.179104 L762.852273,443.179104 M751.5,472.014925 L757.176136,481.626866 L762.642045,491.029851 L740.357955,491.029851 L745.823864,481.626866 L751.5,472.014925 M770,439 L733,439 L742.25,454.671642 L749.397727,467 L742.25,479.328358 L733,495 L770,495 L760.75,479.328358 L753.602273,467 L760.75,454.671642 L770,439 Z",
    id: "Shape",
    fill: "#3F2F90",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1354,123 L1369,97.7309237 L1384,123 L1354,123 Z M1354,71 L1383.78873,71 L1368.78873,96.2690763 L1354,71 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1380.64205,73.1791045 L1375.17614,82.5820896 L1369.5,92.1940299 L1363.82386,82.5820896 L1358.35795,73.1791045 L1380.64205,73.1791045 M1369.5,102.014925 L1375.17614,111.626866 L1380.64205,121.029851 L1358.35795,121.029851 L1364.03409,111.626866 L1369.5,102.014925 M1388,69 L1351,69 L1360.25,84.6716418 L1367.39773,97 L1360.25,109.328358 L1351,125 L1388,125 L1378.75,109.328358 L1371.60227,97 L1378.75,84.6716418 L1388,69 L1388,69 Z",
    id: "Shape",
    fill: "#3F2F90",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1902,454 L1917,428.629032 L1932,454 L1902,454 Z M1902,402 L1931.78873,402 L1916.78873,427.370968 L1902,402 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1927.64205,404.179104 L1921.96591,413.58209 L1916.28977,423.19403 L1910.61364,413.58209 L1904.9375,404.179104 L1927.64205,404.179104 M1916.5,433.014925 L1922.17614,442.626866 L1927.85227,452.029851 L1905.56818,452.029851 L1911.24432,442.626866 L1916.5,433.014925 M1935,400 L1898,400 L1907.25,415.671642 L1914.39773,428 L1907.25,440.328358 L1898,456 L1935,456 L1925.75,440.328358 L1918.60227,428 L1925.75,415.671642 L1935,400 Z",
    id: "Shape",
    fill: "#3F2F90",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1479,114.20979 L1504.26908,129.104895 L1479,144 L1479,114.20979 Z M1505.73092,128.895105 L1531,114 L1531,143.58042 L1505.73092,128.895105 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1481.1791,118.357955 L1490.58209,123.823864 L1500.19403,129.5 L1490.58209,135.176136 L1481.1791,140.642045 L1481.1791,118.357955 M1528.8209,118.357955 L1528.8209,140.642045 L1519.41791,135.176136 L1509.80597,129.5 L1519.41791,123.823864 L1528.8209,118.357955 M1533,111 L1517.32836,120.25 L1505,127.397727 L1492.67164,120.25 L1477,111 L1477,148 L1492.67164,138.75 L1505,131.602273 L1517.32836,138.75 L1533,148 L1533,111 Z",
    id: "Shape",
    fill: "#3F2F90",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#EC008C",
    strokeWidth: 3,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 360,
    y: 636,
    width: 398,
    height: 127
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#F7C556",
    strokeWidth: 3,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 1357,
    y: 27,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#F7C556",
    strokeWidth: 3,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 1369,
    cy: 25.5,
    rx: 35,
    ry: 11.5
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#EC008C",
    strokeWidth: 3,
    points: "846 311 743.78797 311 743.78797 62 568 62 568 98.1384228"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M878.035938,254 L1144.96406,254 C1172.59897,254 1195,276.291667 1195,303.791667 L1195,319.208333 C1195,346.708333 1172.59897,369 1144.96406,369 L878.035938,369 C850.401027,369 828,346.708333 828,319.208333 L828,303.791667 C828,276.291667 850.401027,254 878.035938,254 Z",
    id: "Path",
    stroke: "#00AEEF",
    strokeWidth: 3,
    fill: "#E4ECF7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#EC008C",
    strokeWidth: 3,
    points: "47 681 61.5 665 76 681"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#EC008C",
    strokeWidth: 3,
    points: "309 631 325 645.5 309 660"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#EC008C",
    strokeWidth: 3,
    points: "661 48 677 62.3941606 661 77"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#EC008C",
    strokeWidth: 3,
    points: "758 174 743.5 190 729 174"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#EC008C",
    strokeWidth: 3,
    points: "614 141 628.5 125 643 141"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#EC008C",
    strokeWidth: 3,
    points: "486 141 500.605839 125 515 141"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#EC008C",
    strokeWidth: 3,
    points: "786 297 802 311.5 786 326"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#00AEEF",
    strokeWidth: 3,
    points: "942 519 958 533.605839 942 548"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#00AEEF",
    strokeWidth: 3,
    points: "721 381 737 395.394161 721 410"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#00AEEF",
    strokeWidth: 3,
    points: "1261 519 1277 533.605839 1261 548"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#EC008C",
    strokeWidth: 3,
    points: "1621 481 1637 495.5 1621 510"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#EC008C",
    strokeWidth: 3,
    points: "1395 253 1409.5 237 1424 253"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#00AEEF",
    strokeWidth: 3,
    points: "1383 185 1368.5 201 1354 185"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#EC008C",
    strokeWidth: 3,
    points: "1927 323 1912.5 339 1898 323"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#EC008C",
    strokeWidth: 3,
    points: "1598 211 1583.60584 227 1569 211"
  }), /*#__PURE__*/React.createElement("text", {
    id: "From-Overflow",
    fill: "#231F20",
    fillRule: "nonzero",
    fontFamily: "Roboto-Medium, Roboto",
    fontSize: 14,
    fontWeight: 400,
    "line-spacing": 21,
    letterSpacing: 0.233333333
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 2322.86292,
    y: 657
  }, "From"), /*#__PURE__*/React.createElement("tspan", {
    x: 2310.5735,
    y: 678
  }, "Overflow")), /*#__PURE__*/React.createElement("path", {
    d: "M2296.22156,635 L2382.77844,635 C2387.80838,635 2392,639.161074 2392,644.154362 L2392,687.845638 C2392,692.838926 2387.80838,697 2382.77844,697 L2296.22156,697 C2291.19162,697 2287,692.838926 2287,687.845638 L2287,644.154362 C2287.20958,639.161074 2291.19162,635 2296.22156,635 Z",
    id: "Path",
    stroke: "#231F20",
    strokeWidth: 1.17
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#231F20",
    strokeWidth: 2,
    points: "1935 607.241546 1935 590 2339.57812 590 2339.57812 634"
  }), /*#__PURE__*/React.createElement("text", {
    id: "VFW-##",
    fill: "#231F20",
    fillRule: "nonzero",
    fontFamily: "Roboto-Medium, Roboto",
    fontSize: 14,
    fontWeight: 400,
    "line-spacing": 21,
    letterSpacing: 0.233333333
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 95,
    y: 716
  }, "VFW"), /*#__PURE__*/React.createElement("tspan", {
    id: "VFW-##-2",
    className: "value",
    x: 82,
    y: 737
  }, "##")), /*#__PURE__*/React.createElement("text", {
    id: "Water-Reservoir-##",
    fill: "#231F20",
    fillRule: "nonzero",
    fontFamily: "Roboto-Medium, Roboto",
    fontSize: 14,
    fontWeight: 400,
    "line-spacing": 21,
    letterSpacing: 0.233333333
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 508.967285,
    y: 660
  }, "Water Reservoir"), /*#__PURE__*/React.createElement("tspan", {
    id: "Water-Reservoir-t1",
    className: "value",
    x: 450.721745,
    y: 690
  }, "Top Level Switch:"), /*#__PURE__*/React.createElement("tspan", {
    id: "Water-Reservoir-t2",
    className: "value",
    x: 450.721745,
    y: 720
  }, "Bottom Level Switch:"), /*#__PURE__*/React.createElement("tspan", {
    id: "Water-Reservoir-t3",
    className: "value",
    x: 450.721745,
    y: 750
  }, "Water Temp:"), /*#__PURE__*/React.createElement("tspan", {
    id: "Water-Reservoir-##-1",
    className: "value",
    x: 599.721745,
    y: 690
  }, "##"), /*#__PURE__*/React.createElement("tspan", {
    id: "Water-Reservoir-##-2",
    className: "value",
    x: 599.721745,
    y: 720
  }, "##"), /*#__PURE__*/React.createElement("tspan", {
    id: "Water-Reservoir-##-3",
    className: "value",
    x: 599.721745,
    y: 750
  }, "##")), /*#__PURE__*/React.createElement("text", {
    id: "Steam-Generator-2-##",
    fill: "#231F20",
    fillRule: "nonzero",
    fontFamily: "Roboto-Medium, Roboto",
    fontSize: 14,
    fontWeight: 400,
    "line-spacing": 21,
    letterSpacing: 0.233333333
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 476.230143,
    y: 222
  }, "Steam"), /*#__PURE__*/React.createElement("tspan", {
    x: 459.007682,
    y: 243
  }, "Generator 2"), /*#__PURE__*/React.createElement("tspan", {
    id: "Steam-Generator-2-##-3",
    className: "value",
    x: 476.221745,
    y: 264
  }, "##")), /*#__PURE__*/React.createElement("text", {
    id: "Water-Pump-2-##",
    fill: "#231F20",
    fillRule: "nonzero",
    fontFamily: "Roboto-Medium, Roboto",
    fontSize: 14,
    fontWeight: 400,
    "line-spacing": 21,
    letterSpacing: 0.233333333
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 482.038249,
    y: 501
  }, "Water"), /*#__PURE__*/React.createElement("tspan", {
    x: 476.182813,
    y: 522
  }, "Pump 2"), /*#__PURE__*/React.createElement("tspan", {
    id: "Water-Pump-2-##-3",
    className: "value",
    x: 486.221745,
    y: 543
  }, "##")), /*#__PURE__*/React.createElement("text", {
    id: "Water-Pump-1-##",
    fill: "#231F20",
    fillRule: "nonzero",
    fontFamily: "Roboto-Medium, Roboto",
    fontSize: 14,
    fontWeight: 400,
    "line-spacing": 21,
    letterSpacing: 0.233333333
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 607.038249,
    y: 501
  }, "Water"), /*#__PURE__*/React.createElement("tspan", {
    x: 601.182812,
    y: 522
  }, "Pump 1"), /*#__PURE__*/React.createElement("tspan", {
    id: "Water-Pump-1-##-3",
    className: "value",
    x: 611.221745,
    y: 543
  }, "##")), /*#__PURE__*/React.createElement("text", {
    id: "Steam-Generator-1-##",
    fill: "#231F20",
    fillRule: "nonzero",
    fontFamily: "Roboto-Medium, Roboto",
    fontSize: 14,
    fontWeight: 400,
    "line-spacing": 21,
    letterSpacing: 0.233333333
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 605.230143,
    y: 222
  }, "Steam"), /*#__PURE__*/React.createElement("tspan", {
    x: 588.007682,
    y: 243
  }, "Generator 1"), /*#__PURE__*/React.createElement("tspan", {
    id: "Steam-Generator-1-##-3",
    className: "value",
    x: 606.221745,
    y: 264
  }, "##")), /*#__PURE__*/React.createElement("text", {
    id: "VFB-1-##",
    fill: "#231F20",
    fillRule: "nonzero",
    fontFamily: "Roboto-Medium, Roboto",
    fontSize: 14,
    fontWeight: 400,
    "line-spacing": 21,
    letterSpacing: 0.233333333
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 649,
    y: 346
  }, "VFB 1"), /*#__PURE__*/React.createElement("tspan", {
    id: "VFB-1-##-2",
    className: "value",
    x: 650,
    y: 367
  }, "##")), /*#__PURE__*/React.createElement("text", {
    id: "VFB-2-##",
    fill: "#231F20",
    fillRule: "nonzero",
    fontFamily: "Roboto-Medium, Roboto",
    fontSize: 14,
    fontWeight: 400,
    "line-spacing": 21,
    letterSpacing: 0.233333333
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 519,
    y: 346
  }, "VFB 2"), /*#__PURE__*/React.createElement("tspan", {
    id: "VFB-2-##-2",
    className: "value",
    x: 520,
    y: 367
  }, "##")), /*#__PURE__*/React.createElement("text", {
    id: "Biological-Filter",
    fill: "#231F20",
    fillRule: "nonzero",
    fontFamily: "Roboto-Medium, Roboto",
    fontSize: 14,
    fontWeight: 400,
    "line-spacing": 21,
    letterSpacing: 0.233333333
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1226,
    y: 28
  }, "Biological Filter")), /*#__PURE__*/React.createElement("text", {
    id: "VVC-##",
    fill: "#231F20",
    fillRule: "nonzero",
    fontFamily: "Roboto-Medium, Roboto",
    fontSize: 14,
    fontWeight: 400,
    "line-spacing": 21,
    letterSpacing: 0.233333333
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1290.13398,
    y: 91
  }, "VVC"), /*#__PURE__*/React.createElement("tspan", {
    id: "VVC-##-2",
    className: "value",
    x: 1280.44349,
    y: 112
  }, "##")), /*#__PURE__*/React.createElement("text", {
    id: "Band-Heater-1-##",
    fill: "#231F20",
    fillRule: "nonzero",
    fontFamily: "Roboto-Medium, Roboto",
    fontSize: 14,
    fontWeight: 400,
    "line-spacing": 21,
    letterSpacing: 0.233333333
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 900.72653,
    y: 200
  }, "Band Heater Top"), /*#__PURE__*/React.createElement("tspan", {
    id: "Band-Heater-1-##-2",
    className: "value",
    x: 1048.72653,
    y: 200
  }, "##")), /*#__PURE__*/React.createElement("text", {
    id: "Band-Heater-2-##",
    fill: "#231F20",
    fillRule: "nonzero",
    fontFamily: "Roboto-Medium, Roboto",
    fontSize: 14,
    fontWeight: 400,
    "line-spacing": 21,
    letterSpacing: 0.233333333
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 900.72653,
    y: 420
  }, "Band Heater Bottom"), /*#__PURE__*/React.createElement("tspan", {
    id: "Band-Heater-2-##-2",
    className: "value",
    x: 1048.72653,
    y: 420
  }, "##")), /*#__PURE__*/React.createElement("text", {
    id: "Chamber-##",
    fill: "#231F20",
    fillRule: "nonzero",
    fontFamily: "Roboto-Medium, Roboto",
    fontSize: 14,
    fontWeight: 400,
    "line-spacing": 21,
    letterSpacing: 0.233333333
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 900.55306,
    y: 300
  }, "Chamber Temperature: "), /*#__PURE__*/React.createElement("tspan", {
    x: 900.55306,
    y: 340
  }, "Chamber Pressure: "), /*#__PURE__*/React.createElement("tspan", {
    id: "Chamber-temp",
    className: "value",
    x: 1070.55306,
    y: 300
  }, "##"), /*#__PURE__*/React.createElement("tspan", {
    id: "Chamber-pressure",
    className: "value",
    x: 1070.55306,
    y: 340
  }, "##")), /*#__PURE__*/React.createElement("text", {
    id: "VEC-##",
    fill: "#231F20",
    fillRule: "nonzero",
    fontFamily: "Roboto-Medium, Roboto",
    fontSize: 14,
    fontWeight: 400,
    "line-spacing": 21,
    letterSpacing: 0.233333333
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1490.59336,
    y: 80
  }, "VEC"), /*#__PURE__*/React.createElement("tspan", {
    id: "VEC-##-2",
    className: "value",
    x: 1478.22174,
    y: 100
  }, "##")), /*#__PURE__*/React.createElement("text", {
    id: "VDR-##",
    fill: "#231F20",
    fillRule: "nonzero",
    fontFamily: "Roboto-Medium, Roboto",
    fontSize: 14,
    fontWeight: 400,
    "line-spacing": 21,
    letterSpacing: 0.233333333
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 777,
    y: 464
  }, "VDR"), /*#__PURE__*/React.createElement("tspan", {
    id: "VDR-##-2",
    className: "value",
    x: 779,
    y: 485
  }, "##")), /*#__PURE__*/React.createElement("text", {
    id: "Fan",
    fill: "#231F20",
    fillRule: "nonzero",
    fontFamily: "Roboto-Medium, Roboto",
    fontSize: 14,
    fontWeight: 400,
    "line-spacing": 21,
    letterSpacing: 0.233333333
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 2063,
    y: 55
  }, "Fan")), /*#__PURE__*/React.createElement("text", {
    id: "Heat-Exchanger-##",
    fill: "#231F20",
    fillRule: "nonzero",
    fontFamily: "Roboto-Medium, Roboto",
    fontSize: 14,
    fontWeight: 400,
    "line-spacing": 21,
    letterSpacing: 0.233333333
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1865,
    y: 135
  }, "Heat Exchanger"), /*#__PURE__*/React.createElement("tspan", {
    id: "Heat-Exchanger-##-3",
    className: "value",
    x: 1892,
    y: 177
  }, "##")), /*#__PURE__*/React.createElement("text", {
    id: "VDHE-##",
    fill: "#231F20",
    fillRule: "nonzero",
    fontFamily: "Roboto-Medium, Roboto",
    fontSize: 14,
    fontWeight: 400,
    "line-spacing": 21,
    letterSpacing: 0.233333333
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1937,
    y: 430
  }, "VDHE"), /*#__PURE__*/React.createElement("tspan", {
    id: "VDHE-##-2",
    className: "value",
    x: 1985,
    y: 430
  }, "##")), /*#__PURE__*/React.createElement("text", {
    id: "Waste-Bottle-Or-Drai",
    fill: "#231F20",
    fillRule: "nonzero",
    fontFamily: "Roboto-Medium, Roboto",
    fontSize: 14,
    fontWeight: 400,
    "line-spacing": 21,
    letterSpacing: 0.233333333
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1882.22598,
    y: 716
  }, "Waste Bottle"), /*#__PURE__*/React.createElement("tspan", {
    x: 1897.13014,
    y: 737
  }, "Or Drain")), /*#__PURE__*/React.createElement("text", {
    id: "From-Auto-Fill",
    fill: "#231F20",
    fillRule: "nonzero",
    fontFamily: "Roboto-Medium, Roboto",
    fontSize: 14,
    fontWeight: 400,
    "line-spacing": 21,
    letterSpacing: 0.233333333
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 20.7807292,
    y: 781
  }, "From Auto Fill")), /*#__PURE__*/React.createElement("text", {
    id: "Lower-manifold",
    fillRule: "nonzero",
    fontFamily: "Roboto-Medium, Roboto",
    fontSize: 14,
    fontWeight: 400,
    "line-spacing": 21,
    letterSpacing: 0.233333333,
    fill: "#212529"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1984,
    y: 550
  }, "Lower manifold")), /*#__PURE__*/React.createElement("text", {
    id: "Upper-manifold",
    fillRule: "nonzero",
    fontFamily: "Roboto-Medium, Roboto",
    fontSize: 14,
    fontWeight: 400,
    "line-spacing": 21,
    letterSpacing: 0.233333333,
    fill: "#212529"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1612,
    y: 13
  }, "Upper manifold")))))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .value { font: 14px sans-serif; }\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchematic);
export default __webpack_public_path__ + "static/media/schematic.a4b9196f90e32a2793fee4a5759490af.svg";
export { ForwardRef as ReactComponent };